import React from "react";

export default function QuestionMarkTooltip({tooltipText, size = "md"}) {
  const sizeClasses = {
    sm: "size-3",
    md: "size-4",
    lg: "size-5",
  };

  return (
    <div className="relative group text-gray-400 cursor-pointer flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2"
           stroke="currentColor" className={sizeClasses[size] || sizeClasses.md}>
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"/>
      </svg>


      {/* Tooltip text */}
      <div
        className="opacity-0 w-max absolute top-[-2.5rem] left-1/2 -translate-x-1/2
               bg-gray-700 text-white text-xs rounded px-2 py-1
               group-hover:opacity-100 transition pointer-events-none z-10"
      >
        {tooltipText}
      </div>
    </div>
  );
}